var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _g2, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 114,
    viewBox: "0 0 132 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M74.8662 96.3377C101.263 96.3377 122.662 74.9703 122.662 48.6124C122.662 22.2545 101.263 0.887146 74.8662 0.887146C48.4695 0.887146 27.0708 22.2545 27.0708 48.6124C27.0708 74.9703 48.4695 96.3377 74.8662 96.3377Z",
    fill: "#F0F1F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.9931 107.781C41.0169 107.781 49.9534 98.8573 49.9534 87.8497C49.9534 76.842 41.0169 67.9186 29.9931 67.9186C18.9693 67.9186 10.0327 76.842 10.0327 87.8497C10.0327 98.8573 18.9693 107.781 29.9931 107.781Z",
    fill: "#F0F1F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M76.8143 50.9835H110.6L126.452 113.113L132 41.4861H43.2278L41.8569 59.1781H71.4745L76.8143 50.9835Z",
    fill: "#1957E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M123.384 36.5467L74.9702 25.3947L59.2043 93.6385L107.619 104.791L123.384 36.5467Z",
    fill: "#F1AA70"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.544 29.9091L58.3105 23.2274L48.8644 92.6254L98.0974 99.3071L107.544 29.9091Z",
    fill: "#2E3E8E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M106.906 27.8213L57.8892 19.7097L46.4216 88.8033L95.4387 96.915L106.906 27.8213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M85.5906 54.6805C85.0991 54.6805 84.6156 54.4516 84.3081 54.0226L71.2193 35.761C70.7128 35.0543 70.8759 34.0714 71.5836 33.5656C72.2913 33.0598 73.2756 33.2227 73.7822 33.9294L86.8709 52.191C87.3774 52.8976 87.2143 53.8805 86.5066 54.3863C86.2286 54.5851 85.9081 54.6805 85.5906 54.6805Z",
    fill: "#52617F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M69.9017 52.0848C69.4103 52.0848 68.9267 51.8559 68.6192 51.4269C68.1127 50.7202 68.2758 49.7373 68.9835 49.2315L87.2719 36.162C87.9797 35.6562 88.964 35.8191 89.4705 36.5257C89.9771 37.2324 89.814 38.2153 89.1062 38.7211L70.8178 51.7906C70.5398 51.9894 70.2193 52.0848 69.9017 52.0848Z",
    fill: "#52617F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.717 54.4459H115.95L126.452 113.113L108.717 54.4459Z",
    fill: "#2E3E8E"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M126.452 113.113L112.69 59.1781L110.6 50.9835H76.8141L71.4743 59.1781H23.9175L37.6787 113.113H126.452Z",
    fill: "#5B87EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.5723 66.2929H45.0653C45.6466 66.2929 46.2379 66.7635 46.3859 67.3439C46.5339 67.9243 46.1826 68.395 45.6013 68.395H34.1083C33.5271 68.395 32.9358 67.9243 32.7877 67.3439C32.6397 66.7635 32.9911 66.2929 33.5723 66.2929Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M35.3565 73.2843H60.4476C61.0289 73.2843 61.6202 73.7549 61.7682 74.3353C61.9162 74.9157 61.5649 75.3864 60.9836 75.3864H35.8925C35.3113 75.3864 34.7199 74.9157 34.5719 74.3353C34.4239 73.7549 34.7753 73.2843 35.3565 73.2843Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M37.1397 80.2757H62.2308C62.8121 80.2757 63.4034 80.7464 63.5514 81.3268C63.6994 81.9072 63.3481 82.3778 62.7668 82.3778H37.6757C37.0945 82.3778 36.5031 81.9072 36.3551 81.3268C36.2071 80.7464 36.5585 80.2757 37.1397 80.2757Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.3,
    d: "M24.2236 77.962C34.155 77.962 42.2059 69.9228 42.2059 60.006C42.2059 50.0892 34.155 42.05 24.2236 42.05C14.2922 42.05 6.24121 50.0892 6.24121 60.006C6.24121 69.9228 14.2922 77.962 24.2236 77.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M24.1834 79.2727C20.3216 79.2727 16.5524 78.1126 13.3005 75.8814C9.05349 72.9679 6.19749 68.5772 5.25771 63.5186C4.31792 58.4599 5.40715 53.3389 8.32494 49.0981C11.2427 44.8573 15.6399 42.0055 20.706 41.0671C25.772 40.1287 30.9006 41.2163 35.1476 44.1299C39.3946 47.0434 42.2506 51.4341 43.1904 56.4927C44.1302 61.5513 43.0409 66.6724 40.1231 70.9132C37.2054 75.1539 32.8082 78.0057 27.7421 78.9441C26.5552 79.1637 25.3646 79.2727 24.1834 79.2727ZM24.2481 43.3608C18.9356 43.3608 13.7093 45.884 10.4797 50.5767C7.95707 54.2421 7.01585 58.6694 7.82775 63.0422C8.64036 67.415 11.1091 71.2102 14.7806 73.7291C18.4513 76.248 22.8851 77.1879 27.265 76.3772C31.6442 75.5657 35.4451 73.1006 37.9677 69.4345C43.1746 61.867 41.2454 51.4807 33.6668 46.2814C30.7885 44.3063 27.5021 43.36 24.2481 43.36V43.3608Z",
    fill: "#52617F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M13.4415 53.9142C13.1864 53.9142 12.9285 53.8396 12.7022 53.6847C12.1073 53.2764 11.9564 52.4636 12.3652 51.8695C16.8579 45.3402 25.8326 43.6779 32.3715 48.164C33.6519 49.0429 34.7727 50.1104 35.7025 51.3372C36.1379 51.9119 36.0243 52.7305 35.4488 53.166C34.8733 53.6007 34.0535 53.4874 33.6174 52.9127C32.8572 51.9097 31.9405 51.0359 30.8915 50.3163C25.5409 46.6452 18.1972 48.0054 14.5207 53.3482C14.267 53.7162 13.8582 53.9142 13.4422 53.9142H13.4415Z",
    fill: "#52617F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M11.143 61.4954C10.4303 61.4954 9.84685 60.9236 9.83607 60.2097C9.82027 59.1551 9.92157 58.0983 10.1364 57.0688C10.2837 56.3628 10.9756 55.9101 11.6826 56.0572C12.3896 56.2043 12.843 56.8959 12.6957 57.6011C12.5196 58.4434 12.4377 59.3072 12.4507 60.1703C12.4614 60.8913 11.8852 61.4839 11.1631 61.4947C11.1567 61.4947 11.1495 61.4947 11.143 61.4947V61.4954Z",
    fill: "#52617F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M12.9645 74.0601L9.14941 79.605L11.3044 81.0833L15.1195 75.5384L12.9645 74.0601Z",
    fill: "#52617F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M1.35619 93.2398C-0.0671375 92.2633 -0.427817 90.3205 0.550047 88.8993L8.4017 77.4885L13.5547 81.024L5.70305 92.4348C4.72519 93.856 2.77952 94.2162 1.35619 93.2398Z",
    fill: "#52617F"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M21.1873 29.9605L20.8379 29.4339C20.075 28.3627 19.7247 26.8759 19.9909 24.9544C20.2424 23.2458 20.268 22.0935 19.7311 21.1372C19.122 20.0532 18.0875 19.7434 16.8381 20.5363C16.1311 21.0016 15.4881 21.7737 15.2238 22.5003L14 21.4708C14.3622 20.5343 15.2906 19.4573 16.3323 18.7732C18.5915 17.2874 20.4601 18.1258 21.3674 19.7414C22.1787 21.1877 22.0177 22.7201 21.7543 24.5525C21.5101 26.2265 21.7214 27.3688 22.3891 28.4142L22.7193 28.9537L21.1873 29.9615V29.9605ZM22.4257 33.2213C21.9839 32.4343 22.165 31.5592 22.8528 31.1068C23.5406 30.6544 24.3226 30.898 24.7635 31.684C25.1815 32.4284 25.0516 33.2995 24.3245 33.7777C23.6367 34.2301 22.8428 33.9658 22.4257 33.2213Z",
    fill: "#C7CCD5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHistory);
export default __webpack_public_path__ + "static/media/no-history.7ff80535d58bc77a883d578fec7c2742.svg";
export { ForwardRef as ReactComponent };